/**
 * @fileoverview GET handler for the "/engagement/filter_type" endpoint
 */
/* eslint-disable camelcase */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementFilterType } from "./constants";
import type { EngagementFilterTypeResult, EngagementFilterTypePayload } from "./types";

export const getEngagementFilterType = reactQueryFetcherAdapter(
  engagementFilterType,
  (
    signal: AbortSignal,
    {
      filterKey,
      appGroupId,
      displayName,
      onlyGetContainedFilter,
      lookBackEnabled,
      filterConfig,
    }: EngagementFilterTypePayload
  ): Promise<EngagementFilterTypeResult> => {
    const args = {
      filter_key: filterKey,
      app_group_id: appGroupId,
      display_name: displayName,
      only_get_contained_filter: onlyGetContainedFilter,
      look_back_enabled: lookBackEnabled,
      filter_config: {},
    };
    if (filterConfig?.namespace) {
      args.filter_config = {
        eventName: filterConfig.name,
        eventNamespace: filterConfig.namespace,
      };
    }
    return fetch("/engagement/filter_type", "POST", args, { signal });
  }
);
